function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export const STATUS_CODE = {
  PRINTER_NOT_FOUND: 1,
  PRINTER_NOT_RESPOND: 2,
  WEB_USB_NOT_REQUESTED: 3,
  WEB_USB_NOT_PAIRED: 4,
  FAILED_TO_PRINT: 10
};

class PrinterError extends Error {
  constructor(message, code) {
    super(message);
    Error.captureStackTrace(this, PrinterError);
    this.name = "PrinterError";
    this.code = code;
  }

}

_defineProperty(PrinterError, "STATUS_CODE", STATUS_CODE);

export default PrinterError;